<div class="ps-3" style="line-height: 2.3">
  <fieldset [disabled]="params && params.data && params.data.IsLoading">
    <input
      #inputField
      type="checkbox"
      class="mid"
      id="{{ id }}"
      value="true"
      [(ngModel)]="params.value"
      (change)="refresh(params)" />
    <label for="{{ id }}"><span></span></label>
  </fieldset>
</div>
